// Texto preto ou branco conforme a luminância do fundo (fórmula WCAG).
//
// Selo de fila e etiqueta usam a cor cadastrada como fundo, e o cadastro
// aceita qualquer cor: amarelo #FFF176 com texto branco fixo dá 1.16:1 de
// contraste (medição do QA em 06/09/2026) — o mínimo AA para texto pequeno
// é 4.5:1. Aqui se escolhe o texto que contrasta mais com a cor recebida.

const canal = (v) => {
	const c = v / 255;
	return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
};

export const corDeTextoSobre = (corDeFundo) => {
	const hex = String(corDeFundo || "").replace("#", "");
	const cheio = hex.length === 3 ? hex.replace(/./g, (c) => c + c) : hex;

	if (!/^[0-9a-f]{6}$/i.test(cheio)) return "#fff";

	const [r, g, b] = [0, 2, 4].map((i) => parseInt(cheio.slice(i, i + 2), 16));
	const luminancia = 0.2126 * canal(r) + 0.7152 * canal(g) + 0.0722 * canal(b);

	// Contraste do branco = 1.05/(L+0.05); do preto = (L+0.05)/0.05.
	return 1.05 / (luminancia + 0.05) >= (luminancia + 0.05) / 0.05
		? "#fff"
		: "#0f172a";
};
